export default function Footer() {
  return (
    <footer className="border-t border-cognac/15 mt-24 bg-cream/40">
      <div className="max-w-6xl mx-auto px-6 md:px-12 py-12 md:py-16 grid md:grid-cols-3 gap-10" data-testid="site-footer">
        <div>
          <p className="label-overline">Aisha Bourdanne</p>
          <p className="font-serif text-2xl text-oxblood mt-2">Free financial consultations,<br/>without the jargon.</p>
        </div>
        <div className="space-y-2 text-sm text-inkSoft">
          <p className="label-overline mb-3">Reach me</p>
          <p>abourdanne@gmail.com</p>
          <p className="text-inkMute">Reply turnaround within 24h on business days.</p>
        </div>
        <div className="space-y-2 text-sm text-inkSoft">
          <p className="label-overline mb-3">A reminder</p>
          <p className="font-serif italic text-cognac text-base">"The best time to plant a tree was 20 years ago. The second best time is now."</p>
        </div>
      </div>
      <div className="border-t border-cognac/10">
        <div className="max-w-6xl mx-auto px-6 md:px-12 py-6 text-xs text-inkMute flex flex-col md:flex-row justify-between gap-2">
          <span>© {new Date().getFullYear()} Aisha Bourdanne · Financial Advisor</span>
          <span className="tracking-widest uppercase">Consultations are complimentary · Confidential</span>
        </div>
      </div>
    </footer>
  );
}
